(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["full-screen-video"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var mq = window.matchMedia('(max-width: 768px)');

    function init(root) {
      if (root.dataset.ready) return;
      root.dataset.ready = '1';

      var slides = Array.prototype.slice.call(root.querySelectorAll('.fsv-slide'));
      if (!slides.length) return;

      var dots = Array.prototype.slice.call(root.querySelectorAll('.fsv-dot'));
      var soundBtn = root.querySelector('.fsv-sound');
      var idx = 0;
      var inView = false;
      var single = slides.length === 1;
      var muted = true; // always start muted so autoplay is allowed

      function videoOf(slide) {
        if (mq.matches) return slide.querySelector('.fsv-vm') || slide.querySelector('.fsv-vd');
        return slide.querySelector('.fsv-vd') || slide.querySelector('.fsv-vm');
      }

      function paintSound() {
        if (!soundBtn) return;
        soundBtn.setAttribute('aria-pressed', muted ? 'false' : 'true');
        soundBtn.setAttribute('aria-label', muted ? 'Turn sound on' : 'Mute video');
      }

      function pauseAll() {
        root.querySelectorAll('video').forEach(function (v) { v.pause(); });
      }

      function play() {
        var v = videoOf(slides[idx]);
        root.querySelectorAll('video').forEach(function (other) { if (other !== v) { other.pause(); other.muted = true; } });
        if (!v || !inView || document.hidden) return;
        v.muted = muted;
        var p = v.play();
        if (p && p.catch) p.catch(function () {
          // Browser refused to play with sound: fall back to muted playback
          if (!v.muted) { muted = true; v.muted = true; paintSound(); v.play().catch(function () {}); }
        });
      }

      function paintDots() {
        dots.forEach(function (d, i) {
          d.classList.toggle('is-done', i < idx);
          var bar = d.firstElementChild;
          if (i !== idx && bar) bar.style.transform = i < idx ? 'scaleX(1)' : 'scaleX(0)';
        });
      }

      function go(n) {
        var old = videoOf(slides[idx]);
        slides[idx].classList.remove('is-active');
        idx = (n + slides.length) % slides.length;
        slides[idx].classList.add('is-active');
        if (old) { old.pause(); try { old.currentTime = 0; } catch (e) {} }
        paintDots();
        play();
      }

      root.querySelectorAll('video').forEach(function (v) {
        v.loop = single;
        v.addEventListener('ended', function () {
          if (!single && v === videoOf(slides[idx])) go(idx + 1);
        });
        v.addEventListener('error', function () {
          if (!single && v === videoOf(slides[idx])) setTimeout(function () { go(idx + 1); }, 800);
        });
        v.addEventListener('timeupdate', function () {
          if (single || v !== videoOf(slides[idx]) || !v.duration) return;
          var bar = dots[idx] && dots[idx].firstElementChild;
          if (bar) bar.style.transform = 'scaleX(' + (v.currentTime / v.duration) + ')';
        });
      });

      dots.forEach(function (d, i) {
        d.addEventListener('click', function () { if (i !== idx) go(i); });
      });

      if (soundBtn) {
        soundBtn.addEventListener('click', function () {
          muted = !muted;
          var v = videoOf(slides[idx]);
          if (v) {
            v.muted = muted;
            if (v.paused && inView) play();
          }
          paintSound();
        });
        paintSound();
      }

      // Only play while the section is on screen; nothing downloads before that
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          inView = entries[0].isIntersecting;
          inView ? play() : pauseAll();
        }, { threshold: 0.25 }).observe(root);
      } else {
        inView = true;
        play();
      }

      document.addEventListener('visibilitychange', function () {
        document.hidden ? pauseAll() : play();
      });

      if (mq.addEventListener) mq.addEventListener('change', function () { pauseAll(); play(); });
    }

    function boot() { document.querySelectorAll('[data-fsv]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var mq = window.matchMedia('(max-width: 989px)');

    function closeAll(strip) {
      var panel = strip.querySelector('.fabb6-mdrop');
      if (panel) panel.hidden = true;
      strip.querySelectorAll('.fabb6-substrip__item--open').forEach(function (li) {
        li.classList.remove('fabb6-substrip__item--open');
        var a = li.querySelector('.fabb6-substrip__link');
        if (a) a.setAttribute('aria-expanded', 'false');
      });
    }

    document.addEventListener('click', function (e) {
      if (!mq.matches) return;

      var link = e.target.closest('.fabb6-substrip__item--has-children > .fabb6-substrip__link');
      var openStrip = document.querySelector('.fabb6-substrip .fabb6-mdrop:not([hidden])');

      if (!link) {
        // tap outside the strip or its panel closes it
        if (openStrip && !e.target.closest('.fabb6-mdrop')) closeAll(openStrip.closest('.fabb6-substrip'));
        return;
      }

      e.preventDefault();
      var li = link.parentElement;
      var strip = li.closest('.fabb6-substrip');
      var panel = strip.querySelector('.fabb6-mdrop');
      var wasOpen = li.classList.contains('fabb6-substrip__item--open');

      closeAll(strip);
      if (wasOpen) return;

      var inner = li.querySelector('.fabb6-subdrop__inner');
      panel.querySelector('.fabb6-mdrop__grid').innerHTML = inner ? inner.innerHTML : '';
      panel.hidden = false;
      li.classList.add('fabb6-substrip__item--open');
      link.setAttribute('aria-expanded', 'true');
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var open = document.querySelector('.fabb6-substrip .fabb6-mdrop:not([hidden])');
      if (open) closeAll(open.closest('.fabb6-substrip'));
    });

    mq.addEventListener && mq.addEventListener('change', function () {
      document.querySelectorAll('.fabb6-substrip').forEach(closeAll);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-video-bubble"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.ready) return;
      root.dataset.ready = '1';

      var bubble = root.querySelector('.pvb__bubble');
      var mini = root.querySelector('.pvb__mini');
      var expandBtn = root.querySelector('.pvb__expand');
      var modal = root.nextElementSibling;
      var big = modal.querySelector('.pvb-modal__video');
      var closeBtn = modal.querySelector('.pvb-modal__close');

      var conn = navigator.connection || {};
      var lowData = conn.saveData || /2g/.test(conn.effectiveType || '');
      function startMini() {
        if (lowData || root.hidden) return;
        mini.muted = true;
        if (!mini.src) mini.src = root.dataset.small;
        var p = mini.play();
        if (p && p.then) p.then(function () { mini.classList.add('is-playing'); }).catch(function () {});
      }

      function whenIdle(fn) {
        var run = function () { ('requestIdleCallback' in window) ? requestIdleCallback(fn, { timeout: 1200 }) : setTimeout(fn, 600); };
        if (document.readyState === 'complete') run();
        else window.addEventListener('load', run, { once: true });
      }
      whenIdle(startMini);

      document.addEventListener('visibilitychange', function () {
        if (document.hidden) mini.pause();
        else if (modal.hidden && mini.src) mini.play().catch(function () {});
      });

      function open() {
        mini.pause();
        if (!big.src) big.src = root.dataset.large;
        modal.hidden = false;
        document.body.classList.add('pvb-lock');
        big.muted = false;
        big.currentTime = 0;
        big.play().catch(function () { big.muted = true; big.play().catch(function () {}); });
        closeBtn.focus();
      }

      function close() {
        big.pause();
        modal.hidden = true;
        document.body.classList.remove('pvb-lock');
        bubble.focus();
        if (mini.src) mini.play().catch(function () {});
      }

      bubble.addEventListener('click', open);
      closeBtn.addEventListener('click', close);
      modal.addEventListener('click', function (e) { if (e.target === modal) close(); });
      big.addEventListener('ended', close);
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) close(); });

      expandBtn.addEventListener('click', open);
    }

    function boot() { document.querySelectorAll('.pvb').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();
})();
